import React from "react";
import { storiesOf } from "@storybook/react";
import { withKnobs, boolean, text } from "@storybook/addon-knobs";
import withReadme from "storybook-readme/with-readme";
import { Language } from "@emcm-ui/component-theme";
import DataCallout from "./index";
import "./DataCallout.css";
import DataCalloutREADME from "../README.md";
import Icon from "@emcm-ui/component-icon";

const stories = storiesOf("Components/DataCallout", module);

stories.addDecorator(withKnobs);
stories.addDecorator(withReadme(DataCalloutREADME));

stories
  .add("Items with tooltip", () => (
    <div style={{ "margin-top": 120 }}>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          eyebrow="Item 1 Eyebrow"
          iconType={<Icon path="./icons/ui/red/decrease.svg" size="s" />}
          state="Decrease"
          value={text("Item 1 Value", "92k")}
          description={text("Item 1 Description", "Lines of code")}
          tooltipText={text("Tooltip Text", "This is a sample text")}
        />
        <DataCallout.Item
          eyebrow="Item 2 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 2 Value", "21")}
          description={text("Item 2 Description", "Developers")}
          tooltipText={text("Tooltip Text", "This is a sample text")}
        />
        <DataCallout.Item
          eyebrow="Years of development Eyebrow"
          iconType={<Icon path="./icons/ui/red/decrease.svg" size="s" />}
          state="Decrease"
          value={text("Item 3 Value", "4")}
          description={text("Item 3 Description", "Years of development")}
          tooltipText={text("Tooltip Text", "This is a sample text")}
        />
      </DataCallout>
    </div>
  ))
  .add("two items", () => (
    <React.Fragment>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          value={text("Data 1 Value", "92k")}
          description={text("Data 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          value={text("Data 2 Value", "21")}
          description={text("Data 2 Description", "Developers")}
        />
      </DataCallout>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          eyebrow="Item 1 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 1 Value", "92k")}
          description={text("Item 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          eyebrow="Item 2 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 2 Value", "21")}
          description={text("Item 2 Description", "Developers")}
        />
      </DataCallout>
    </React.Fragment>
  ))
  .add("three items", () => (
    <React.Fragment>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          value={text("Data 1 Value", "92k")}
          description={text("Data 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          value={text("Data 2 Value", "21")}
          description={text("Data 2 Description", "Developers")}
        />
        <DataCallout.Item
          value={text("Data 3 Value", "4")}
          description={text("Data 3 Description", "Years of development")}
        />
      </DataCallout>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          eyebrow="Item 1 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 1 Value", "92k")}
          description={text("Item 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          eyebrow="Item 2 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 2 Value", "21")}
          description={text("Item 2 Description", "Developers")}
        />
        <DataCallout.Item
          eyebrow="Years of development Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 3 Value", "4")}
          description={text("Item 3 Description", "Years of development")}
        />
      </DataCallout>
    </React.Fragment>
  ))
  .add("four items", () => (
    <React.Fragment>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          value={text("Data 1 Value", "92k")}
          description={text("Data 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          value={text("Data 2 Value", "21")}
          description={text("Data 2 Description", "Developers")}
        />
        <DataCallout.Item
          value={text("Data 3 Value", "4")}
          description={text("Data 3 Description", "Years of development")}
        />
        <DataCallout.Item
          value={text("Item 4 Value", "100m")}
          description={text("Item 4 Description", "Users")}
        />
      </DataCallout>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          eyebrow="Item 1 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 1 Value", "92k")}
          description={text("Item 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          eyebrow="Item 2 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 2 Value", "21")}
          description={text("Item 2 Description", "Developers")}
        />
        <DataCallout.Item
          eyebrow="Years of development Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 3 Value", "4")}
          description={text("Item 3 Description", "Years of development")}
        />
        <DataCallout.Item
          eyebrow="Users Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 4 Value", "100m")}
          description={text("Item 4 Description", "Users")}
        />
      </DataCallout>
    </React.Fragment>
  ))
  .add("five items", () => (
    <React.Fragment>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          value={text("Data 1 Value", "92k")}
          description={text("Data 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          value={text("Data 2 Value", "21")}
          description={text("Data 2 Description", "Developers")}
        />
        <DataCallout.Item
          value={text("Data 3 Value", "4")}
          description={text("Data 3 Description", "Years of development")}
        />
        <DataCallout.Item
          value={text("Item 4 Value", "100m")}
          description={text("Item 4 Description", "Users")}
        />
        <DataCallout.Item
          value={text("Item 5 Value", "1")}
          description={text("Item 5 Description", "Catastrophic bug")}
        />
      </DataCallout>
      <DataCallout
        borderAndBackground={boolean("borderAndBackground", false)}
        horizontalContentAtDesktop={boolean(
          "horizontalContentAtDesktop",
          false
        )}
      >
        <DataCallout.Item
          eyebrow="Item 1 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 1 Value", "92k")}
          description={text("Item 1 Description", "Lines of code")}
        />
        <DataCallout.Item
          eyebrow="Item 2 Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 2 Value", "21")}
          description={text("Item 2 Description", "Developers")}
        />
        <DataCallout.Item
          eyebrow="Years of development Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 3 Value", "4")}
          description={text("Item 3 Description", "Years of development")}
        />
        <DataCallout.Item
          eyebrow="Users Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 4 Value", "100m")}
          description={text("Item 4 Description", "Users")}
        />
        <DataCallout.Item
          eyebrow="Catastrophic bug Eyebrow"
          iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
          state="Increase"
          value={text("Item 5 Value", "1")}
          description={text("Item 5 Description", "Catastrophic bug")}
        />
      </DataCallout>
    </React.Fragment>
  ))
  .add("Language: Arabic (RTL)", () => (
    <Language code="ar">
      <React.Fragment>
        <DataCallout
          borderAndBackground={boolean("borderAndBackground", false)}
          horizontalContentAtDesktop={boolean(
            "horizontalContentAtDesktop",
            false
          )}
        >
          <DataCallout.Item
            value={text("Item 1 Value", "92k")}
            description={text(
              "Item 1 Description",
              "أسطر من التعليمات البرمجية"
            )}
          />
          <DataCallout.Item
            value={text("Item 2 Value", "21")}
            description={text("Item 2 Description", "المطورون")}
          />
          <DataCallout.Item
            value={text("Item 3 Value", "4")}
            description={text("Item 3 Description", "سنوات من التطوير")}
          />
          <DataCallout.Item
            value={text("Item 4 Value", "100m")}
            description={text("Item 4 Description", "المستخدمين")}
          />
          <DataCallout.Item
            value={text("Item 5 Value", "1")}
            description={text("Item 5 Description", "علة كارثية")}
          />
        </DataCallout>
        <DataCallout
          borderAndBackground={boolean("borderAndBackground", false)}
          horizontalContentAtDesktop={boolean(
            "horizontalContentAtDesktop",
            false
          )}
        >
          <DataCallout.Item
            eyebrow="Catastrophic bug Eyebrow"
            iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
            state="Increase"
            value={text("Item 1 Value", "92k")}
            description={text(
              "Item 1 Description",
              "أسطر من التعليمات البرمجية"
            )}
          />
          <DataCallout.Item
            eyebrow="Catastrophic bug Eyebrow"
            iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
            state="Increase"
            value={text("Item 2 Value", "21")}
            description={text("Item 2 Description", "المطورون")}
          />
          <DataCallout.Item
            eyebrow="Catastrophic bug Eyebrow"
            iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
            state="Increase"
            value={text("Item 3 Value", "4")}
            description={text("Item 3 Description", "سنوات من التطوير")}
          />
          <DataCallout.Item
            eyebrow="Catastrophic bug Eyebrow"
            iconType={<Icon path="./icons/ui/green/increase.svg" size="s" />}
            state="Increase"
            value={text("Item 4 Value", "100m")}
            description={text("Item 4 Description", "المستخدمين")}
          />
          <DataCallout.Item
            eyebrow="Catastrophic bug Eyebrow"
            iconType={<Icon path="./icons/ui/red/decrease.svg" size="s" />}
            state="Decrease"
            value={text("Item 5 Value", "1")}
            description={text("Item 5 Description", "علة كارثية")}
          />
        </DataCallout>
      </React.Fragment>
    </Language>
  ));
